export const tabs = {
    aria: {
        moreTabLabel: 'More',
    },
};
//# sourceMappingURL=tabs.js.map